// types
import type { Period } from 'components/shared/DateNavigation/DateNavigation.types';
import type { RosterPlanColumnsVisibility } from '../RosterPlan.types';

/**
 * Which balance columns the employee grid shows, from the `employeeCounters` preference.
 *
 * The counter numbers are a persisted per-user contract shared with the Dojo screen, so they are
 * spelled out one by one rather than derived: renumbering them would silently change what existing
 * users see.
 *
 * `employeeCounters` is optional because `state.preferences` is an empty object until the boot saga
 * has filled it, and the screen renders before that.
 */
export const getRosterPlanColumnsVisibility = ({
  employeeCounters,
  period
}: {
  employeeCounters?: number[];
  period: Period | null;
}): RosterPlanColumnsVisibility => {
  const isEnabled = (counter: number) =>
    employeeCounters?.includes(counter) ?? false;

  return {
    showCommitmentHours: isEnabled(1),
    // the week balance is meaningless outside a week view, so the period gates it
    showBalanceWeek: isEnabled(2) && period === 'week',
    showBalanceMonth: isEnabled(3),
    showCumulativeBalance: isEnabled(4),
    showWorkedBalance: isEnabled(5),
    showLeaveBalance: isEnabled(6),
    showYearlyLeaveBalance: isEnabled(7),
    showPlbBalance: isEnabled(8),
    showPlbYearBalance: isEnabled(9)
  };
};
